import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import AppRoutes from './routes/Approutes';
import { AppProvider } from './context/AppContext';
import './index.css';

const App = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <Navbar />
        <main><AppRoutes /></main>
        <Footer />
      </AppProvider>
    </BrowserRouter>
  );
};

export default App;
